
export enum kScheduling {
  chooseService = 'chooseService',
  assistanceMode = 'assistanceMode',
  region = 'region',
  regionFailSorry = 'regionFailSorry',
  regionFailRequest = 'regionFailRequest',
  regionFailRequestSent = 'regionFailRequestSent',
  phoneNumber = 'phoneNumber',
  language = 'language',
  languageFailSorry = 'languageFailSorry',
  languageFailRequest = 'languageFailRequest',
  languageFailRequestSent = 'languageFailRequestSent',
  chooseTopics = 'chooseTopics',
  practicalSupportIntakeInfo = 'practicalSupportIntakeInfo',
  chooseDate = 'chooseDate',
  chooseCounsellor = 'chooseCounsellor',
  counsellorBio = 'counsellorBio',
  confirmSession = 'confirmSession',
  appointmentCreated = 'appointmentCreated',
  appointmentError = 'appointmentError',
  serviceAlreadyBooked = 'serviceAlreadyBooked',
}
